import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import "../../zisComponents/grid/Grid.scss";
import "./Ziadosti.scss";

// coraWebComponents
import Button from "../../coraWebComponents/buttons/Button";
import { buildUrl } from "../../coraWebComponents/utils/helper";
import { dateToStr, dateToDateStr } from "../../coraWebComponents/utils/convert";
import { getBlob } from "../../utils/filesUtils";
import * as filesActions from "../../actions/filesActions";

const ZiadostDetail = (props) => {
  const [src, setSrc] = useState(null);

  const { dataItem } = props;
  const { OblastZaujmu } = dataItem;

  const getSrc = useCallback(async () => {
    if (OblastZaujmu.I_SCREENSHOT && src === null) {
      try {
        const data = await getBlob(OblastZaujmu.I_SCREENSHOT);
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          setSrc(reader.result);
        }
      }
      catch (error) {
        setSrc(null);
      }
    }
  }, [OblastZaujmu.I_SCREENSHOT, setSrc]);

  useEffect(() => {
    getSrc();
  }, [])

  const renderOsobaData = (data) => {
    const { Adresa, Kontakt, OsobneUdaje } = data;

    const { I_O_TYP, MENO, PRIEZVISKO, ICO, NAZOV } = OsobneUdaje;
    const { ADRESA_MERGED } = Adresa;
    const { EMAIL, TELEFON } = Kontakt;

    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">
            {I_O_TYP === 1 ? "Meno a priezvisko:" : "Názov a IČO:"}
          </div>
          <div className="col-6 p-0 gridDetailCol">
            {I_O_TYP === 1 ? `${MENO} ${PRIEZVISKO}` : `${NAZOV} ${ICO}`}
          </div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Adresa:"}</div>
          <div className="col-6 p-0 gridDetailCol">{ADRESA_MERGED}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Telefón:"}</div>
          <div className="col-6 p-0 gridDetailCol">{TELEFON}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Email:"}</div>
          <div className="col-6 p-0 gridDetailCol">{EMAIL}</div>
        </div>
      </>
    );
  };
  const renderDovodPrioritaData = (dovod, priorita) => {
    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Druh:"}</div>
          <div className="col-6 p-0 gridDetailCol">{dovod.N_DOVOD}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Priorita:"}</div>
          <div className="col-6 p-0 gridDetailCol">{priorita.N_PRIORITA}</div>
        </div>
      </>
    );
  };
  const renderDetailStavbyData = (data) => {
    const { N_TYP_PRACE, NAZOV_PROJEKTU } = data;

    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Typ práce:"}</div>
          <div className="col-6 p-0 gridDetailCol">{N_TYP_PRACE}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Názov projektu / Názov stavby:"}</div>
          <div className="col-6 p-0 gridDetailCol">{NAZOV_PROJEKTU}</div>
        </div>
      </>
    );
  };
  const renderAdresaStavbyData = (ADRESA_STAVBA) => {
    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Adresa:"}</div>
          <div className="col-6 p-0 gridDetailCol">{ADRESA_STAVBA}</div>
        </div>
      </>
    );
  };
  const renderStaveniskoData = (data) => {
    const { STAVENISKO_NAZOV, STAVENISKO_KONTAKT, STAVENISKO_VEDUCI } = data;

    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">
            {"Názov spoločnosti:"}
          </div>
          <div className="col-6 p-0 gridDetailCol">{STAVENISKO_NAZOV}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Vedúci stavby:"}</div>
          <div className="col-6 p-0 gridDetailCol">{STAVENISKO_VEDUCI}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Kontakt:"}</div>
          <div className="col-6 p-0 gridDetailCol">{STAVENISKO_KONTAKT}</div>
        </div>
      </>
    );
  };
  const renderDoleziteData = (data) => {
    const { D_POZADOVANE_VYBAVENIE, D_ZAC_STAVBY, D_UKONC_STAVBY, CIS_ZIAD_ISV, ID_STAV_ISV } = data;
    const isAnyDateSet = D_POZADOVANE_VYBAVENIE || D_ZAC_STAVBY || D_UKONC_STAVBY;
    return (
      <>
        {isAnyDateSet && (
          <div className="row m-0">
            <div className="col-6 p-0 gridDetailCol">{"Požadovaný dátum vybavenia:"}</div>
            <div className="col-6 p-0 gridDetailCol">{dateToDateStr(D_POZADOVANE_VYBAVENIE)}</div>
          </div>
        )}
        {isAnyDateSet && (
          <div className="row m-0">
            <div className="col-6 p-0 gridDetailCol">{"Dátum zač. stavby:"}</div>
            <div className="col-6 p-0 gridDetailCol">{dateToDateStr(D_ZAC_STAVBY)}</div>
          </div>
        )}
        {isAnyDateSet && (
          <div className="row m-0">
            <div className="col-6 p-0 gridDetailCol">{"Dátum ukon. stavby:"}</div>
            <div className="col-6 p-0 gridDetailCol">{dateToDateStr(D_UKONC_STAVBY)}</div>
          </div>
        )}
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Číslo žiadosti z IS výstavby:"}</div>
          <div className="col-6 p-0 gridDetailCol">{CIS_ZIAD_ISV}</div>
        </div>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"ID stavby z IS výstavby:"}</div>
          <div className="col-6 p-0 gridDetailCol">{ID_STAV_ISV}</div>
        </div>
      </>
    );
  };
  const renderPrilohyKomentareData = (data) => {
    const { KOMENTAR, Prilohy } = data;
    const { downloadPriloha } = props;

    return (
      <>
        <div className="row m-0">
          <div className="col-6 p-0 gridDetailCol">{"Komentár:"}</div>
          <div className="col-6 p-0 gridDetailCol">{KOMENTAR}</div>
        </div>
        {Prilohy.map((priloha, key) => {
          const { FILE_NAME, I_AG_ZIAD_BIN } = priloha;
          return (
            <div
              key={key}
              className="row m-0 download-label-button-container"
            >
              <div className="col-6 p-0 gridDetailCol">{FILE_NAME}</div>
              <div className="col-6 p-0 gridDetailCol download-button">
                <Button
                  imageUrl={buildUrl("assets/notify_stiahnut.svg")}
                  onClick={async () =>
                    await downloadPriloha(I_AG_ZIAD_BIN, FILE_NAME, false)
                  }
                />
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const renderVyjadrenie = (data) => {
    const { downloadPriloha } = props;

    return (
      <>
        {
          data.map((item, i) => {
            return (
              <div key={i} className="row m-0 border-bottom">
                <div className="col-6 p-0 gridDetailCol">
                  <div className="row m-0">
                    <div className="col-2 p-0 gridDetailCol">{"Výsledok:"}</div>
                    <div className="col-4 p-0 gridDetailCol">{item.Vysledok.N_VYSLEDOK}</div>
                    <div className="col-6 p-0 gridDetailCol">{dateToStr(item.D_VYJADRENIE)}</div>
                  </div>
                  <div className="row m-0">
                    <div className="col-2 p-0 gridDetailCol">{"Komentár:"}</div>
                    <div className="col-10 p-0 gridDetailCol">{item.KOMENTAR}</div>
                  </div>
                </div>
                <div className="col-6 p-0 gridDetailCol">
                  {
                    item.Priloha.map((file, j) => {
                      return (
                        <div key={i * 100 + j} className="row m-0 download-label-button-container">
                          <div className="col-6 p-0 gridDetailCol">
                            {file.FILE_NAME}
                          </div>
                          <div className="col-6 p-0 gridDetailCol download-button">
                            <Button
                              imageUrl={buildUrl("assets/notify_stiahnut.svg")}
                              onClick={async () => await downloadPriloha(file.I_AG_VYJADRENIE_BIN, file.FILE_NAME, true)}
                            />
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>)
          })
        }
      </>
    )
  };

  const renderOblastZaujmuData = (ADRESA_STAVBA) => {
    return (
      <>
        <div className="row m-0">
          <div className="col-2 p-0 gridDetailCol">{"Adresa:"}</div>
          <div className="col-10 p-0 gridDetailCol">
            {ADRESA_STAVBA}
          </div>
        </div>
        <div className="row m-0">
          <div className="col-12 p-0 gridDetailCol imageContainer">
            {src && (
              <img
                className="imageMap"
                src={src}
                alt="ThumnailPhoto"
              ></img>
            )}
          </div>
        </div>
      </>
    );
  };

  const {
    DetailStavby,
    Dovod,
    Priorita,
    InfoZiadatel,
    PrilohyKomentar,
    Vyjadrenie,
    ADRESA_STAVBA
  } = dataItem;

  const { Ziadatel, Vlastnik } = InfoZiadatel;

  return (
    <>
      {/* ZIADATEL/VLASTNIK - HLAVICKA*/}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          <strong>Žiadateľ:</strong>
        </div>
        <div className="col-6 p-0 gridDetailCol">
          <strong>Vlastník:</strong>
        </div>
      </div>
      {/* ZIADATEL/VLASTNIK - DATA*/}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          {renderOsobaData(Ziadatel)}
        </div>
        <div className="col-6 p-0 gridDetailCol">
          {renderOsobaData(Vlastnik)}
        </div>
      </div>

      {/* SEPARATOR */}
      <div className="row m-0 ziadostDetailSeparator" />

      {/* DOVOD ZIADOSTI/DETAIL STAVBY - HLAVICKA*/}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          <strong>Druh žiadosti:</strong>
        </div>
        <div className="col-6 p-0 gridDetailCol">
          <strong>Detail stavby:</strong>
        </div>
      </div>
      {/* DOVOD ZIADOSTI/DETAIL STAVBY - DATA*/}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          {renderDovodPrioritaData(Dovod, Priorita)}
        </div>
        <div className="col-6 p-0 gridDetailCol">
          {renderDetailStavbyData(DetailStavby)}
        </div>
      </div>

      {/* SEPARATOR */}
      <div className="row m-0 ziadostDetailSeparator" />

      {/* ADRESA STAVBY/STAVENISKO - HLAVICKA*/}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          <strong>Adresa stavby:</strong>
        </div>
        <div className="col-6 p-0 gridDetailCol">
          <strong>Stavenisko:</strong>
        </div>
      </div>
      {/* ADRESA STAVBY/STAVENISKO - DATA*/}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          {renderAdresaStavbyData(ADRESA_STAVBA)}
        </div>
        <div className="col-6 p-0 gridDetailCol">
          {renderStaveniskoData(DetailStavby)}
        </div>
      </div>

      {/* SEPARATOR */}
      <div className="row m-0 ziadostDetailSeparator" />

      {/* DOLEZITE DATA/PRILOHY A KOMENTARE - HLAVICKA */}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          <strong>Dôležité dáta:</strong>
        </div>
        <div className="col-6 p-0 gridDetailCol">
          <strong>Prílohy a komentáre:</strong>
        </div>
      </div>
      {/* DOLEZITE DATA/PRILOHY A KOMENTARE - DATA */}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          {renderDoleziteData(DetailStavby)}
        </div>
        <div className="col-6 p-0 gridDetailCol">
          {renderPrilohyKomentareData(PrilohyKomentar)}
        </div>
      </div>

      {/* SEPARATOR */}
      <div className="row m-0 ziadostDetailSeparator" />

      {/* VYJADRENIE - HLAVICKA */}
      <div className="row m-0">
        <div className="col-6 p-0 gridDetailCol">
          <strong>Vyjadrenie:</strong>
        </div>
        <div className="col-6 p-0 gridDetailCol">
          <strong>Dokumenty:</strong>
        </div>
      </div>
      {/* VYJADRENIE - DATA */}
      {renderVyjadrenie(Vyjadrenie)}
      {/* SEPARATOR */}
      <div className="row m-0 ziadostDetailSeparator" />

      {/* OBLAST ZAUJMU - HLAVICKA */}
      <div className="row m-0">
        <div className="col-12 p-0 gridDetailCol">
          <strong>Oblasť záujmu:</strong>
        </div>
      </div>
      {/* OBLAST ZAUJMU - DATA */}
      <div className="row m-0">
        <div className="col-12 p-0 gridDetailCol">
          {renderOblastZaujmuData(ADRESA_STAVBA)}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  downloadPriloha: (I_AG_ZIAD_BIN, FILE_NAME, L_VYJADRENIE) =>
    dispatch(filesActions.downloadPriloha(I_AG_ZIAD_BIN, FILE_NAME, L_VYJADRENIE)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZiadostDetail);